import Cookies from 'js-cookie'

import { SelectionOption } from '@cash-web/protos/squareup/franklin/blockers/selection_blocker.pb'

import { MAGIC_LINK_COOKIE } from './constants'
import { isMagicLinkAction } from './isMagicLinkAction'
export const tryAddMagicLinkRedirect = (option?: SelectionOption) => {
  // add a magic link redirect if we have any query string params.
  if (option != null && isMagicLinkAction(option) && window.location.search !== '') {
    Cookies.set(MAGIC_LINK_COOKIE, window.location.search, { expires: 1 }) // set cookie to expire in 1 day
  }
}
